import { EditOutlined, DeleteOutlined } from '@ant-design/icons'
import { useState } from 'react'
import { ButtonCommon, PopoverCommon } from 'src/common'
import PopconfirmCommon from 'src/common/PopconfirmCommon/PopconfirmCommon'
import { useAppDispatch, useModalCommon } from 'src/hooks'
import { onDeleteDictWordExample } from 'src/redux/definition/definition.actions'
import { showMessageError, showMessageSuccess } from 'src/utils/function.utils'
import { FormEditExample } from '../FormEditExample/FormEditExample'
import './ExampleItem.scss'

const ExampleItem = ({
	id,
	wordMeaningID,
	dictWordID,
	example,
	translation,
}) => {
	const dispatch = useAppDispatch()
	const {
		visible: visibleModalDelete,
		openModal: openModalDelete,
		closeModal: closeModalDelete,
	} = useModalCommon()

	const [isDeleteLoading, setIsDeleteLoading] = useState(false)

	const handleDelete = () => {
		setIsDeleteLoading(true)
		dispatch(
			onDeleteDictWordExample(
				{
					id,
				},
				handleDeleteCb
			)
		)
	}

	const handleDeleteCb = (isSuccess, rs) => {
		setIsDeleteLoading(false)
		if (isSuccess) {
			showMessageSuccess('Delete successfully')
		} else {
			showMessageError(rs)
		}
	}

	return (
		<div className="u-row-between">
			<div className="example-item">
				<span>{example}</span>
				<div className="translation">{translation}</div>
			</div>
			<div className="u-row">
				<PopconfirmCommon
					visible={visibleModalDelete}
					onConfirm={handleDelete}
					title="Are you sure to delete this example permanently?"
					placement="left"
					okButtonProps={{ loading: isDeleteLoading }}
					onCancel={closeModalDelete}
				>
					<ButtonCommon
						icon={<DeleteOutlined />}
						size="small"
						ghost
						type="danger"
						onClick={openModalDelete}
					></ButtonCommon>
				</PopconfirmCommon>

				<PopoverCommon
					content={
						<FormEditExample
							id={id}
							initialValues={{
								example,
								translate: translation,
							}}
							wordMeaningID={wordMeaningID}
							dictWordID={dictWordID}
						/>
					}
					trigger="click"
				>
					<ButtonCommon
						icon={<EditOutlined />}
						size="small"
						ghost
						type="primary"
					></ButtonCommon>
				</PopoverCommon>
			</div>
		</div>
	)
}

export default ExampleItem
